var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 5.84179V5.83331H53.3275C54.8035 5.83331 56 7.04747 56 8.47811V56.5218C56 57.9826 54.8136 59.1666 53.3509 59.1666H10.6491C9.18603 59.1666 8 57.9669 8 56.4818V21.8333L24 5.84179ZM15.5445 21.8333H24V13.3823L15.5445 21.8333ZM29.3333 11.1666V24.5C29.3333 25.9727 28.1395 27.1666 26.6667 27.1666H13.3333V53.8333H50.6667V11.1666H29.3333Z",
    fill: "#182A4C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLine);
export default __webpack_public_path__ + "static/media/file-line.fa34090e13395825c7906e0a1061123a.svg";
export { ForwardRef as ReactComponent };